/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'
import { Container, Row, Col } from 'react-grid-system'

import H1 from '../typography/H1'
import H3 from '../typography/H3'
import IconClock from '../svg/IconClock'
import IconPeople from '../svg/IconPeople'
import IconThumbsUp from '../svg/IconThumbsUp'
import P from '../typography/P'
import P2 from '../typography/P2'
import theme, { mq } from '../../theme'

interface SectionColumnProps {
  Icon: any
  title: string
  addBr?: boolean
  children: React.ReactNode
}

export const SectionColumn: React.FC<SectionColumnProps> = (props) => {
  const { Icon, title, children, addBr } = props
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '2em',
      }}
    >
      <div
        css={[
          mq('d-flex'),
          mq('flex-center'),
          mq('', 'xs', { width: '28px', height: '28px' }),
        ]}
      >
        <Icon variant="gray" width="100%" />
      </div>
      <H3>
        {title}
        {!!addBr && (
          <span css={[mq('d-none', 'xs'), mq('d-inline', 'md')]}>
            <br />
            &nbsp;
          </span>
        )}
      </H3>
      <P2>{children}</P2>
    </div>
  )
}

const AboutUsSection2: React.FC = () => {
  const title1 = 'Save Precious Time'
  const title2 = 'Expert Advice'
  const title3 = 'Access to our database of thousands of artists'
  return (
    <div
      css={{
        backgroundColor: 'white',
        padding: '2em 0px',
        textAlign: 'center',
      }}
    >
      <Container>
        <Row>
          <Col>
            <H1>Why Join Us</H1>
            <P css={[mq('center'), { maxWidth: '750px' }]}>
              At The Artling Projects, it’s as simple as inputting a project’s
              timeline, budget, and preferred artwork style. We'll take care of
              the rest..
            </P>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <SectionColumn title={title1} Icon={IconClock} addBr={true}>
              Save yours and your team’s valuable time using our sourcing tools
              with multiple sources aggregated in one location.
            </SectionColumn>
          </Col>
          <Col xs={12} md={4}>
            <SectionColumn title={title2} Icon={IconThumbsUp} addBr={true}>
              Draw on our art consultants’ years of experience, and let them
              advise and suggest artworks based on your project’s needs.
            </SectionColumn>
          </Col>
          <Col xs={12} md={4}>
            <SectionColumn title={title3} Icon={IconPeople}>
              We work with artists, designers and galleries across the world,
              giving you access to artworks for a wide range of budgets and
              styles.
            </SectionColumn>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AboutUsSection2
